import React from "react";
import WalletInfo from "./WalletInfo";
import BuyPanel from "./BuyPanel";
import RewardsPanel from "./RewardsPanel";
import WalletPanel from "./WalletPanel";
import { WalletContext } from "./App";
import ShopPanel from "./ShopPanel";

export default function LobbyRight() {
    let wallet = React.useContext(WalletContext);

    return (
        <div style={{width: '280px', textAlign: 'center'}}>
            { wallet.key ?
                <div>
                    <WalletPanel/>
                    <WalletInfo/>
                    <BuyPanel/>
                    <RewardsPanel/>
                    <ShopPanel/>
                    {/*<TweetPanel />*/}
                </div>
                :
                <div className='flexColumn'>
                    <div style={{marginTop: '20px', fontSize: '30px', fontWeight: 'bold', fontStyle: 'italic'}}>Let's Play!</div>
                    <WalletPanel/>
                    <div style={{fontSize: '20px', width: '75%'}}>
                        To play duckracerz game, connect your Phantom Wallet :)
                    </div>

                </div>
            }
        </div>
    );
}
